import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-09",
  "use": "icon-sheet_icon-09-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-09\"><g transform=\"translate(-450 -217)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"452.75\" y=\"224.25\" width=\"18.5\" height=\"14.5\" rx=\"2\" /><path d=\"M470.91 225.57l-4.167 5.6c-.187.25-.494.4-.822.4h-7.842c-.328 0-.635-.15-.822-.4l-4.166-5.6\" stroke-linecap=\"round\" /><path d=\"M458 225v-2.5c0-1.38.895-2.5 2-2.5h4c1.105 0 2 1.12 2 2.5v2.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol